import {
  SET_DOMEX_STEP,
  SET_DOMEX_PHASE,
  SET_DOMEX_SUBMISSION_REF,
  SET_DOMEX_SAME_AS_SUBSCRIBER,
  SET_DOMEX_ACTIVE_BENEFICIARY,
  SET_DOMEX_CONTRACT_FIELD,
  SET_DOMEX_PERSON_FIELD,
  SET_DOMEX_BENEFICIARY_FIELD,
  SET_DOMEX_CONSENT,
  ADD_DOMEX_BENEFICIARY,
  REMOVE_DOMEX_BENEFICIARY,
  COPY_SUBSCRIBER_TO_INSURED,
  SET_DOMEX_FILE,
  SET_DOMEX_ERRORS,
  SET_DOMEX_ERROR,
  CLEAR_DOMEX_ERRORS,
  SET_DOMEX_LOADING,
  RESET_DOMEX,
} from "./mutation-types";

import service from "@/service";
import config from "@/config";
import axios from "axios";

const $service = service(axios, config);

export default {
  // ── Navigation ──────────────────────────────────────────────────
  applyDomexSetStep({ commit }, step) {
    commit(SET_DOMEX_STEP, step);
  },

  applyDomexSetPhase({ commit }, phase) {
    commit(SET_DOMEX_PHASE, phase);
  },

  // ── Champs contrat ──────────────────────────────────────────────
  applyDomexSetContractField({ commit }, { key, value }) {
    commit(SET_DOMEX_CONTRACT_FIELD, { key, value });
  },

  // ── Champs souscripteur / assuré (avec sync auto) ───────────────
  applyDomexSetPersonField({ commit, state }, { target, key, value }) {
    commit(SET_DOMEX_PERSON_FIELD, { target, key, value });
    if (target === "subscriber" && state.sameAsSubscriber) {
      commit(SET_DOMEX_PERSON_FIELD, { target: "insured", key, value });
    }
  },

  // ── Champs bénéficiaire ─────────────────────────────────────────
  applyDomexSetBeneficiaryField({ commit }, { index, key, value }) {
    commit(SET_DOMEX_BENEFICIARY_FIELD, { index, key, value });
  },

  // ── Consentements ───────────────────────────────────────────────
  applyDomexSetConsent({ commit }, { key, value }) {
    commit(SET_DOMEX_CONSENT, { key, value });
  },

  // ── Toggle "assuré = souscripteur" ──────────────────────────────
  applyDomexSetSameAsSubscriber({ commit }, value) {
    commit(SET_DOMEX_SAME_AS_SUBSCRIBER, value);
    if (value) {
      commit(COPY_SUBSCRIBER_TO_INSURED);
    }
  },

  // ── Bénéficiaires ───────────────────────────────────────────────
  applyDomexSetActiveBeneficiary({ commit }, index) {
    commit(SET_DOMEX_ACTIVE_BENEFICIARY, index);
  },

  applyDomexAddBeneficiary({ commit }) {
    commit(ADD_DOMEX_BENEFICIARY);
  },

  applyDomexRemoveBeneficiary({ commit }, index) {
    commit(REMOVE_DOMEX_BENEFICIARY, index);
  },

  // ── Fichiers ────────────────────────────────────────────────────
  applyDomexSetFile({ commit }, { key, file }) {
    commit(SET_DOMEX_FILE, { key, file });
  },

  // ── Erreurs ─────────────────────────────────────────────────────
  applyDomexSetErrors({ commit }, { section, errors }) {
    commit(SET_DOMEX_ERRORS, { section, errors });
  },

  applyDomexClearErrors({ commit }) {
    commit(CLEAR_DOMEX_ERRORS);
  },

  // ── Validation d'étape (renvoie true/false) ─────────────────────
  applyDomexValidateStep({ commit, state }, step) {
    let ok = true;

    // ── Étape 0 : Contrat
    // ── Étape 0 : Contrat ──
    if (step === 0) {
      const c = state.form.contract;
      const e = {};
      if (!c.projectType || !c.projectType.trim()) {
        e.projectType = "Type de projet requis.";
        ok = false;
      }
      if (!c.apporteurType) {
        e.apporteurType = "Sélectionnez un apporteur.";
        ok = false;
      }
      if (
        c.apporteurType === "Autre" &&
        (!c.apporteurCustom || !c.apporteurCustom.trim())
      ) {
        e.apporteurCustom = "Veuillez préciser l'apporteur.";
        ok = false;
      }
      if (!c.cotisation || c.cotisation < 6000) {
        e.cotisation = "La cotisation minimale est de 6 000 FCFA.";
        ok = false;
      }
      if (!c.duration) {
        e.duration = "Sélectionnez la durée.";
        ok = false;
      }
      if (!c.effectDate) {
        e.effectDate = "Date d'effet requise.";
        ok = false;
      }
      commit(SET_DOMEX_ERRORS, { section: "contract", errors: e });
      return ok;
    }

    // ── Étape 1 : Souscripteur, Étape 2 : Assuré ──
    // Champs OBLIGATOIRES réduits : civilité, prénom, nom, téléphone
    // Tous les autres sont optionnels
    if (step === 1 || step === 2) {
      if (step === 2 && state.sameAsSubscriber) return true;
      const target = step === 1 ? "subscriber" : "insured";
      const p = state.form[target];
      const e = {};
      if (!p.civility) {
        e.civility = "Civilité requise.";
        ok = false;
      }
      if (!p.firstName || !p.firstName.trim()) {
        e.firstName = "Prénom requis.";
        ok = false;
      }
      if (!p.lastName || !p.lastName.trim()) {
        e.lastName = "Nom requis.";
        ok = false;
      }
      if (!p.phoneNumber || !p.phoneNumber.trim()) {
        e.phone = "Téléphone requis.";
        ok = false;
      }
      // Email facultatif mais s'il est saisi, doit être valide
      if (
        p.email &&
        p.email.trim() &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email)
      ) {
        e.email = "Email invalide.";
        ok = false;
      }
      commit(SET_DOMEX_ERRORS, { section: target, errors: e });
      return ok;
    }

    // ── Étape 3 : Bénéficiaires
    // ── Étape 3 : Bénéficiaires ──
    // Champs OBLIGATOIRES réduits : nom, prénom, téléphone
    if (step === 3) {
      const allErrs = [];
      state.form.beneficiaries.forEach((b) => {
        const e = {};
        if (!b.firstName || !b.firstName.trim()) {
          e.firstName = "Prénom requis.";
          ok = false;
        }
        if (!b.lastName || !b.lastName.trim()) {
          e.lastName = "Nom requis.";
          ok = false;
        }
        if (!b.phoneNumber || !b.phoneNumber.trim()) {
          e.phone = "Téléphone requis.";
          ok = false;
        }
        allErrs.push(e);
      });
      commit(SET_DOMEX_ERRORS, { section: "beneficiaries", errors: allErrs });
      return ok;
    }

    // ── Étape 4 : Consentements
    if (step === 4) {
      const f = state.form;
      if (!f.consentExact || !f.consentData || !f.consentTerms) {
        commit(SET_DOMEX_ERROR, {
          key: "consent",
          message: "Vous devez accepter les conditions obligatoires (*).",
        });
        return false;
      }
      commit(SET_DOMEX_ERROR, { key: "consent", message: "" });
      return true;
    }

    return true;
  },

  // ════════════════════════════════════════════════════════════════
  // ── Soumission RÉELLE au backend NestJS ─────────────────────────
  // ════════════════════════════════════════════════════════════════
  async applyDomexSubmit({ commit, state, dispatch }) {
    const isValid = await dispatch("applyDomexValidateStep", 4);
    if (!isValid) return { status: 400 };

    commit(SET_DOMEX_LOADING, { key: "submit", value: true });
    commit(SET_DOMEX_ERROR, { key: "submit", message: "" });

    try {
      // ─── Construction du FormData ────────────────────────────────
      const fd = new FormData();

      // 1. Payload JSON
      const payload = {
        contract: {
          projectType: state.form.contract.projectType,
          apporteur:
            state.form.contract.apporteurType === "Autre"
              ? state.form.contract.apporteurCustom
              : state.form.contract.apporteurType,
          cotisation: Number(state.form.contract.cotisation),
          duration: state.form.contract.duration,
          effectDate: state.form.contract.effectDate,
        },
        subscriber: { ...state.form.subscriber },
        // Si l'assuré est identique, on ne l'envoie pas
        insured: state.sameAsSubscriber ? undefined : { ...state.form.insured },
        sameAsSubscriber: state.sameAsSubscriber,
        beneficiaries: state.form.beneficiaries.map((b) => ({ ...b })),
        consents: {
          exact: state.form.consentExact,
          data: state.form.consentData,
          terms: state.form.consentTerms,
        },
      };

      fd.append("data", JSON.stringify(payload));

      // 2. Fichiers (CNI)
      if (state.files.subscriberCni) {
        fd.append(
          "subscriberCni",
          state.files.subscriberCni,
          state.files.subscriberCni.name
        );
      }
      if (!state.sameAsSubscriber && state.files.insuredCni) {
        fd.append(
          "insuredCni",
          state.files.insuredCni,
          state.files.insuredCni.name
        );
      }

      // ─── Appel API ───────────────────────────────────────────────
      const result = await $service.submitDomexContract(fd);

      // ─── Succès ──────────────────────────────────────────────────
      const ref = result?.data?.reference || result?.data?.ref || "—";
      commit(SET_DOMEX_SUBMISSION_REF, ref);
      commit(SET_DOMEX_PHASE, "success");
      commit(SET_DOMEX_LOADING, { key: "submit", value: false });

      return { status: 201, data: result.data };
    } catch (error) {
      alert(
        "Une erreur est survenue lors de la soumission. Vérifiez votre connexion et réessayez. Si le problème persiste, contactez le support."
      );
      // ─── Gestion d'erreur détaillée ──────────────────────────────
      let msg = "Une erreur est survenue. Veuillez réessayer.";

      if (error.code === "ECONNABORTED") {
        msg =
          "La requête a pris trop de temps. Vérifiez votre connexion et la taille des fichiers.";
      } else if (error.response) {
        const status = error.response.status;
        const data = error.response.data;

        if (status === 400) {
          if (Array.isArray(data?.message)) {
            msg = data.message.join(" · ");
          } else if (typeof data?.message === "string") {
            msg = data.message;
          } else {
            msg = "Données invalides. Vérifiez vos informations.";
          }
        } else if (status === 413) {
          msg = "Fichier trop volumineux. Les CNI doivent faire moins de 5 Mo.";
        } else if (status === 415) {
          msg = "Format de fichier non supporté. Utilisez PDF, JPG ou PNG.";
        } else if (status >= 500) {
          msg =
            "Erreur serveur. Notre équipe a été notifiée. Veuillez réessayer dans quelques instants.";
        } else if (data?.message) {
          msg = typeof data.message === "string" ? data.message : msg;
        }
      } else if (error.request) {
        msg =
          "Impossible de joindre le serveur. Vérifiez votre connexion internet.";
      }

      commit(SET_DOMEX_ERROR, { key: "submit", message: msg });
      commit(SET_DOMEX_LOADING, { key: "submit", value: false });

      console.error("[Domex submit] Erreur :", error);
      return { status: error.response?.status || 500, error: msg };
    }
  },

  // ── Reset complet ───────────────────────────────────────────────
  applyDomexReset({ commit }) {
    commit(RESET_DOMEX);
  },
};
